{
  "common" : {
    "customFieldExistsError" : "Anpassad Fält med det här namnet finns redan",
    "uniqueKeyNotUniqueError" : "Denna Nyckel är inte unik",
    "save" : "Spara",
    "saving" : "Sparar",
    "integrate" : "Integrera",
    "preview" : "Förhandsgranska",
    "back" : "Tillbaka",
    "alert" : "Avisering",
    "proceed" : "Fortsätt",
    "cancel" : "Avbryt",
    "delete" : "Radera",
    "embed" : "Inbäddad",
    "link" : "Länk",
    "iframeEmbed" : "Iframe-inbäddning",
    "styles" : "Stilar",
    "options" : "Alternativ",
    "quickAdd" : "Snabbtillägg",
    "customFields" : "Anpassade fält",
    "addObjectFields" : "Lägg till objektfält",
    "personalInfo" : "Personuppgifter",
    "contactInfo" : "Kontaktuppgifter",
    "submit" : "Skicka",
    "address" : "Adress",
    "customized" : "Anpassad",
    "layout" : "Layout",
    "showLabel" : "Visa etikett",
    "background" : "Bakgrund",
    "buttonBackground" : "Knapp Bakgrund",
    "fontColour" : "Typsnitt",
    "textFontColour" : "Text Font Colour",
    "subTextFontColour" : "Sub Text Font Colour",
    "selectThemes" : "Välj Tema",
    "filled" : "Ifylld",
    "textOnly" : "Endast Brödtext",
    "border" : "Kantlinje",
    "borderType" : "Kantlinjetyp",
    "cornerRadius" : "Hörnradie",
    "width" : "Bredd",
    "padding" : "Utfyllnad",
    "top" : "Toppen",
    "bottom" : "Botten",
    "left" : "Vänster",
    "right" : "Höger",
    "center" : "Centrera",
    "default" : "Form Default",
    "default" : "Standard",
    "formDefault" : "Standardformulär",
    "shadow" : "Skugga",
    "color" : "Färg",
    "horizontal" : "Horisontell",
    "vertical" : "Vertikal",
    "blur" : "Oskärpa",
    "spread" : "Storlek",
    "fieldStyle" : "Fältstil",
    "fontColor" : "Typsnittsfärg",
    "inputTextFillColor" : "Fyllnadsfärg för inmatningstext",
    "inputTextColor" : "Textfärg för inmatning",
    "primaryColor" : "Primärfärg",
    "primaryColorTooltip" : "Kontrollerar Färg för hovringsläge och Dynamisk Land.",
    "inputTextColorTooltip" : "Kontrollerar Färg av SMS:a som skrivs in i feedback Fält.",
    "mapPrimaryColorToButtonColor" : "Mappa PRIMÄR Färg till Knapp Färg",
    "label" : "Etikett",
    "fontFamily" : "Typsnittsfamilj",
    "size" : "Storlek",
    "weight" : "Tjocklek",
    "placeholder" : "Platshållare",
    "customCSS" : "Anpassad CSS",
    "backgroundImage" : "Bakgrundsbild",
    "headerImage" : "Sidhuvudbild",
    "miscellaneous" : "Övrigt",
    "agencyBranding" : "Byråns varumärke",
    "imageUploadMessage" : "Klicka på eller dra en bild till det här området för att ladda upp",
    "backgroundImageTooltipMessage" : "Bakgrundsbilden är avsedd att täcka hela sidan och ger en visuellt tilltalande bakgrund för formuläret. För att se bakgrundsbilden klickar du på på alternativet Förhandsgranska.",
    "headerImageTooltipMessage" : "Sidhuvudbilden är utformad för att täcka hela formulärets bredd och placeras högst upp i formuläret. För att se sidhuvudbilden klickar du alternativet Förhandsgranska.",
    "onSubmit" : "Vid inlämning",
    "facebookPixelID" : "Facebook Pixel-ID",
    "facebookPixelIDMessage" : "Ignorera det här fältet om du planerar att använda formuläret/undersökningen i en tratt",
    "facebookPixelEvents" : "Facebook Pixel-händelser",
    "onpageView" : "Vid sidvisning",
    "stickyContact" : "Fäst kontakt",
    "stickyContactMessage" : "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "fieldDescription" : "Fältbeskrivning",
    "fieldTitle" : "Fälttitel",
    "queryKey" : "Frågenyckel",
    "querykeyTooltipMessage" : "Frågenyckeln som kan användas som URL-parameter för att fylla i det här fältet",
    "required" : "Krävs",
    "hidden" : "Dold",
    "hiddenValue" : "Dolt värde",
    "enableCountryPicker" : "Aktivera landsväljare",
    "altText" : "Alt-text",
    "alignment" : "Orientering",
    "imageWidth" : "Bildbredd",
    "imageHeight" : "Bildhöjd",
    "logic" : "Logik",
    "pleaseInput" : "Ange",
    "editHTML" : "Redigera HTML",
    "textStyle" : "Textformat",
    "subText" : "Undertext",
    "text" : "Text",
    "buttonStyle" : "Knappstil",
    "fullWidth" : "Full bredd",
    "htmlMessage" : "Anpassad HTML anges här",
    "htmlEditorHeader" : "ANPASSAD JAVASCRIPT / HTML",
    "htmlEditorBodyMessage" : "Lägg till din kod här",
    "yesSave" : "Ja, spara",
    "cancelKeep" : "Avbryt, behåll",
    "done" : "Klar",
    "addElement" : "Lägg till element",
    "addUrlLike" : "Lägg till giltiga URL:er som",
    "doNotAddRelativePath" : "Lägg inte till relativa sökvägar som",
    "or" : "eller",
    "addCustomFields" : "Lägg till anpassade fält",
    "customFieldSearch" : "Sök efter namn",
    "enterSourceValue" : "Ange källvärde",
    "shortLabel" : "Kort etikett",
    "shortLabelPlaceholder" : "Typsnitt a Kort etikett",
    "labelPlaceholder" : "Typ en etikett",
    "fileUploadPlaceholder" : "Ladda upp a Fil",
    "customCSSTooltip" : "Anpassad CSS har företräde framför formulärformatering och teman och kan ha en inverkan på temats stil.",
    "fontFamilyTooltip" : "Byggverktyget stöder alla typer av typsnitt om du inte kan se det i listan. Sök i rullgardinsmenyn",
    "useGDPRCompliantFont" : "Använd GDPR-kompatibelt typsnitt",
    "enableTimezone" : "Aktivera tidszon",
    "inputStyle" : "Inmatningsstil",
    "conditionalLogicAlertOnSubmit" : "Villkorlig logik kommer att ha företräde framför meddelandet/omdirigeringen här",
    "conditionalLogicAlertOnShowHide" : "Villkorlig logik kommer att ha företräde framför de dolda inställningarna här",
    "placeholderFacebookPixelIdInput" : "Ange Facebook Pixel-ID",
    "doNotShowMessage" : "Visa inte igen",
    "creatingForm" : "Skapade din Formulär ...",
    "creatingSurvey" : "Skapade din Undersökning...",
    "creatingQuiz" : "Skapade ditt quiz ...",
    "errorCreatingForm" : "Där var ett fel skapat din Formulär. Försök igen.",
    "errorCreatingSurvey" : "Där blev det ett fel skapade din Undersökning. Försök igen.",
    "errorCreatingQuiz" : "Där var ett fel skapade ditt quiz. Försök igen.",
    "redirectMessage" : "You will be redirected to:",
    "themes" : {
      "themes" : "Teman",
      "alertThemeMessage" : "Om du byter tema kommer du att förlora alla ändringar av den aktuella stilen.",
      "useTheme" : "Använd tema",
      "removeTheme" : "Ta bort tema"
    },
    "box" : "Ruta",
    "line" : "Rad",
    "message" : "Meddelande",
    "openUrl" : "Öppna URL",
    "borderTypeList" : {
      "dotted" : "Prickad",
      "dashed" : "Streckad",
      "solid" : "Helfärgad",
      "none" : "Ingen"
    },
    "button" : "Knapp",
    "emailNotification" : "E-postavisering",
    "emailNotificationSubheader" : "Få ett e-postmeddelande när någon fyller i ditt formulär",
    "subject" : "Ämne",
    "emailTo" : "E-post (till)",
    "senderName" : "Avsändarens namn",
    "senderNameWarning" : "Ditt (underkontonamn) läggs till om det lämnas tomt",
    "emailError" : "Minst en e-postadress krävs",
    "emailTooltip" : "Den första e-postadressen är avsedd för fältet ”Till”. Eventuella efterföljande e-postadresser kommer att inkluderas i fältet ”CC”.",
    "clear" : "Rensa",
    "showNotificationsSettings" : "Visa aviseringsinställningar",
    "emailServicePaid" : "Den här funktionen är en betald tjänst och kommer att medföra avgifter baserat på din användning.",
    "integration" : "Integration",
    "validation" : {
      "fieldRequired" : "Fält är Krävs",
      "maxLengthExceeded" : "Max längd har överskridits ({max} Tecken)"
    },
    "payment" : {
      "payments" : "Betalningar",
      "connected" : "Ansluten",
      "connect" : "Anslut",
      "liveModeOn" : "Live-läge",
      "status" : "Status",
      "test" : "Test",
      "live" : "Live",
      "paymentFields" : "Betalningsfält",
      "suggestAnAmount" : "Föreslå ett belopp",
      "selectCurrency" : "Välj valuta",
      "tagActiveBGColor" : "Färg på aktiv tagg",
      "includeOtherAmount" : "Inkludera annat belopp",
      "footerInfo" : "Sidfotsinfo",
      "paymentType" : "Betalningstyp",
      "sellProducts" : "Sälj produkter",
      "customAmount" : "Anpassat belopp",
      "collectPayment" : "Ta ut betalning",
      "generalSettings" : "Allmänna fält",
      "securePayments" : "*100 % Lås & säkra betalningar*",
      "error" : {
        "addMainProductFirst" : "Lägg till en PRIMÄR Produkt först",
        "priceNotFoundForBumpProduct" : "Pris hittades inte för Tilläggsprodukt",
        "productAlreadyAdded" : "Produkt har redan lagts till"
      },
      "product" : {
        "addProduct" : "Lägg till produkt",
        "productSettings" : "Produktinställningar",
        "selectProduct" : "Välj produkt",
        "editThisProduct" : "För att redigera produkten",
        "clickHere" : "Klicka här",
        "show" : "Visa",
        "description" : "Beskrivning",
        "image" : "Bild",
        "layoutSettings" : "Layoutinställningar",
        "singleColumn" : "En kolumn",
        "twoColumn" : "Två kolumner",
        "threeColumn" : "Tre kolumner",
        "maxProductError" : "Max 20 produkter är tillåtna i ett formulär",
        "productSelectPlaceholder" : "Välj en produkt",
        "orderConfirmation" : "Beställningsbekräftelse",
        "orderConfirmationWarning" : "En beställningsbekräftelsesida kommer att visas när betalningen har genomförts",
        "quantity" : "Antal",
        "createProduct" : "Så här skapar du en produkt",
        "noProductsAdded" : "Inga produkter har lagts till än",
        "productsWillShowHere" : "När Du Inkludera produkter kommer de Visa upp Höger här",
        "chooseProductType" : "Välj Produkt Typ",
        "mainProduct" : "PRIMÄR Produkt"
      },
      "bumProduct" : {
        "price" : "Pris",
        "variant" : "Variant",
        "headline" : "Rubrik",
        "otoHeadline" : "OTO Rubrik",
        "otoText" : "OTO Brödtext",
        "enableImage" : "Aktivera Bild",
        "imageMessage" : "Vi tar Standard Produkt Bild",
        "orUploadADifferentImage" : "Eller Ladda upp en annan Bild",
        "bumpProducts" : "Bump-produkter",
        "bumpProduct" : "Tilläggsprodukt",
        "enableBump" : "Aktivera Bump",
        "orderBumpStyle" : "Beställningstillägg Stil",
        "classic" : "Klassisk",
        "modern" : "Modernt",
        "icon" : "Ikon",
        "bumpTemplate" : "Välj Mall",
        "highlightText" : "Markera Brödtext",
        "showPrice" : "Visa Pris",
        "bumpPriceColor" : "Högre Pris",
        "bumpIconColor" : "Bump Ikon",
        "bumpBackgroundColor" : "Bump Bakgrund",
        "highlightTextColor" : "Markera Brödtext",
        "headlineColor" : "Rubrik",
        "otoHeadlineColor" : "OTO Rubrik",
        "otoTextColor" : "OTO Brödtext",
        "bumpBorderColor" : "Bump Kantlinje",
        "priceRequired" : "Pris är Krävs",
        "headlineRequired" : "Rubrik är Krävs",
        "bumpProductTooltip" : "Ett Liten Tillägg erbjöds under Kassa till Multiplicera Sortera Värde. Kunder kan Inkludera det med en Individ-klick.",
        "templateOne" : "Mall 1",
        "templateTwo" : "Mall 2",
        "templateThree" : "Mall 3",
        "animationIcon" : {
          "none" : "Ingen",
          "arrow" : "Pil",
          "fire" : "Brand",
          "plus" : "Plus",
          "giftBox" : "Ruta",
          "timer" : "Nedräkning",
          "cracker" : "Knackare",
          "snack" : "Mellanmål",
          "partyBalloon" : "Festballong",
          "flash" : "Blixt",
          "money" : "Valuta",
          "spaceShuttle" : "Yta"
        }
      },
      "coupons" : {
        "coupons" : "Kuponger",
        "enableCoupon" : "Aktivera kupong",
        "couponAlignment" : "Kupongjustering",
        "left" : "Vänster",
        "right" : "Höger",
        "fullWidth" : "Full bredd",
        "tooltipMessage" : "Ställ in positionen för kuponginmatning från typerna nedan"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Adress fylls i automatiskt",
      "addressfields" : "Adressfält",
      "placeholderSearch" : "Sök efter en adress",
      "autoCompleteTooltip" : "Gör det möjligt söka efter och automatiskt fylla i adress.",
      "streetAddress" : "Adress",
      "autoCompleteAddressTitle" : "Auto Slutför Adress",
      "newBadge" : "Ny",
      "defaultLabel" : "Adress",
      "searchPlaceholder" : "Sök adress",
      "mandataorySearch" : {
        "title" : "Krävs till Välj adress in Sök Bar",
        "primaryText" : "Automatisk komplettering endast för Adress",
        "secondaryText" : "När Aktiverad, När a Användare interagerar med Adressfältet, Sedan måste de välja en giltig adress till Fortsätt.",
        "secondaryText1" : "När Inaktiverad Sedan kan de Fortsätt utan att välja en adress in fältet Sök."
      }
    },
    "autoResponder" : "Autosvar",
    "autoResponderSubheader" : "Skicka ett automatiskt e-postmeddelande till personen som skickar in formuläret (e-postmeddelandet innehåller en kopia av den information som de angav i formuläret)",
    "replyToEmail" : "Svarsmejl",
    "open" : "Öppen",
    "won" : "Vunnen",
    "lost" : "Förlorad",
    "abandon" : "Överge",
    "selectAPipeline" : "Välj en pipeline",
    "stage" : "Stadium",
    "status" : "Status",
    "opportunityValue" : "Möjlighetens värde",
    "createNewPipeline" : "Skapa ny pipeline",
    "editOpportunitySettings" : "Redigera möjlighetsinställningar",
    "contact" : "Kontakt",
    "opportunity" : "Möjlighet",
    "business" : "Företag",
    "add" : "Lägg till",
    "more" : "Mer",
    "opportunityHeading" : "Var vill du att din möjlighet ska uppdateras?",
    "date" : {
      "dateSettings" : "Datuminställningar",
      "dateFormat" : "Datumformat",
      "dateSeparator" : "Datumavdelare",
      "dateFormatTooltipMessage" : "Välj ett datumformat. D står för dag, M för månader och Y för år",
      "dateSeparatorTooltipMessage" : "Välj en avdelare som separerar dag, månad och år i det format som valts i Datumformat",
      "disablePicker" : "Inaktivera väljare"
    },
    "restoreVersion" : "Återställ version",
    "versionHistory" : "Versionshistorik",
    "errorMessage" : "Fel, försök igen",
    "version" : "Version:",
    "currentVersion" : "Nuvarande version",
    "messageStyling" : "Meddelandeformat",
    "validateEmailHeader" : "Validera e-post",
    "validateEmailDescription" : "Knappen blir synlig när användaren anger sin e-postadress. Den här funktionen är utformad för att hjälpa dig att generera potentiella kunder av hög kvalitet.",
    "validatePhoneHeader" : "Validera telefon",
    "validatePhoneDescription" : "Knappen blir synlig när användaren anger sitt telefonnummer. Den här funktionen är utformad för att hjälpa dig att generera potentiella kunder av hög kvalitet.",
    "validatePhoneWarning" : "För att aktivera SMS OTP-verifiering behöver du se till att ditt telefonnummer är inställt i platsinställningarna",
    "addAnotherTnc" : "Add another T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Type DELETE to confirm",
    "style" : {
      "formLayoutType" : "Formulärtyp",
      "layoutType" : "Layout Type",
      "surveyType" : "Survey Type",
      "oneColumn" : "En kolumn",
      "twoColumn" : "Två kolumner",
      "singleLine" : "En rad",
      "fieldWidth" : "Fältbredd",
      "labelAlignment" : {
        "labelAlignment" : "Etikettjustering",
        "labelWidth" : "Etikettbredd"
      },
      "fieldSpacing" : "Fältavstånd",
      "color" : "färg",
      "fontColor" : "Typsnittsfärg",
      "inputBackgroundColor" : "Bakgrundsfärg för inmatning",
      "inputBorder" : "Feedback Kantlinje",
      "layout" : "Layout",
      "colorsAndBackground" : "Färger och bakgrund",
      "advanceSettings" : "Avancerade Inställningar",
      "inputField" : "Inmatningsfält",
      "borderWidth" : "Kantlinjebredd",
      "borderColor" : "Kantlinjefärg",
      "borderStyle" : "Kantlinjestil",
      "fontSize" : "Teckenstorlek",
      "fontWeight" : "Typsnittstjocklek",
      "labelColor" : "Etikettfärg",
      "placeholderColor" : "Platshållarfärg",
      "shortLabelColor" : "Färg på kort etikett"
    },
    "replyToTooltip" : "Anpassa standardsvarsmejlen genom att använda {'{'}{'{'}contact.email{'}'}{'}'} för att aktivera svar till kontakten som skickar formuläret.",
    "content" : "Innehåll",
    "calculations" : "Beräkningar",
    "uploadOptions" : "Uppladdningsalternativ",
    "opportunitySettingsWarning" : "Ange möjlighetsinställningar genom att klicka på knappen Redigera möjlighetsinställningar.",
    "question" : "Fråga",
    "createContactOnPartialSubmission" : "Skapa kontakt vid partiell inlämning",
    "howItWorks" : "Hur fungerar det?",
    "createContactOnPartialSubmissionDescription" : "Slutför bilden och klicka på ”Nästa”. En ny kontakt skapas och lagras automatiskt.",
    "swapWarningMessageSurvey" : "Om alternativ redigeras eller byts ut påverkas det anpassade fältet på alla platser där fältet används. Det kan också återställa villkorlig logik. ",
    "swapWarningMessageForm" : "Om alternativ redigeras eller byts ut påverkas det anpassade fältet på alla platser där fältet används. ",
    "migrationWarningMessage" : "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel" : "Alternativetikett",
    "calculationValue" : "Beräkningsvärde",
    "addOption" : "Lägg till alternativ",
    "enableCalculations" : "Aktivera beräkningar",
    "allowOtherOption" : "Allow Other Option",
    "productSelectionSubtext" : "Aktivera Individ Eller urval av flera produkter",
    "multi" : "Flera",
    "single" : "Individ",
    "productSelectionHeading" : "Produkt",
    "spreadToColumns" : "Sprid ut till kolumner",
    "columns" : "Kolumner",
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble",
    "integratePopup" : {
      "embedCode" : "Embed Code",
      "useInFunnelOrEmbedCode" : "Use in Funnel/ Embed Code",
      "iframeEmbed" : "Inbäddad iframe",
      "funnel" : {
        "funnel" : "Tratt",
        "chooseStep" : "Välj a Steg",
        "copyCodeAndOpenFunnel" : "Kopiera Kod och Öppna Tratt"
      },
      "share" : {
        "share" : "Share",
        "shareViaSocials" : "Dela Via Sociala medier",
        "copyLink" : "Kopiera länk"
      },
      "email" : {
        "email" : "E-post",
        "shareViaEmail" : "Dela Via E-post",
        "emailButton" : "E-post",
        "blankTemplate" : "Tom Mall",
        "emailMarketingTemplates" : "Mallar för E-post Marknadsföring",
        "or" : "Eller",
        "chooseTemplate" : "Choose from your templates",
        "continue" : "Fortsätt"
      }
    },
    "rating" : {
      "icon" : "Ikon",
      "iconAlignment" : "Ikon Orientering",
      "count" : "Antal",
      "lowestRating" : "Min Betyg",
      "highestRating" : "Max",
      "iconSelectedState" : "Ikon Markerad Delstat",
      "iconUnselectedState" : "Ikon Avmarkerat Delstat",
      "rating" : "Betyg",
      "ratingSettings" : "Betyg Inställningar",
      "calculationType" : {
        "calculationType" : "Hur man Arkivera Betyg Fält in Anpassad Fält",
        "calculationTypeTooltip" : "När Du Frekvens något 4 Från 5 stjärnor betyder det: - Absolut: 4 från 5 - Procentsats: 80 - Bråk: 0,8",
        "absolute" : "Absolut",
        "percentage" : "Procentsats",
        "fraction" : "Bråk"
      }
    },
    "desktopMode" : "Datorläge",
    "mobileMode" : "Mobilläge",
    "versions" : "Varianter",
    "advanced" : "Advanced",
    "edit" : "Edit",
    "settings" : "Settings",
    "submissions" : "Submissions",
    "undo" : "Undo",
    "redo" : "Redo",
    "confirmationMessage" : "Confirmation Message",
    "deleteOption" : "Alternativ för Radera",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Raderar ett alternativ kommer att påverka detta Anpassad-fält över varje Platser där fältet används. Är du säker på att du vill Radera det?",
      "validationMessage" : "Vänligen ange Radera till Spara.",
      "validationError" : "Vänligen ange Radera"
    },
    "disqualifyImmediately" : "Disqualify Immediately",
    "disqualifyAfterSubmit" : "Disqualify After Submit",
    "generalSettings" : "Allmän Inställningar",
    "advancedSettings" : "Avancerade Inställningar",
    "customFieldName" : "Anpassad Bransch Namn",
    "customFieldNameTooltip" : "Denna Bransch Namn är unik per Anpassad Bransch.",
    "uniqueKey" : "Unik nyckel",
    "uniqueKeyTooltip" : "Detta Nyckel är unikt per Anpassad Bransch.",
    "survey" : {
      "layoutType" : "Survey Type",
      "oneQuestionPerPage" : "One Question at a Time",
      "allQuestionsOnePage" : "Many at a Time"
    },
    "quizQuestions" : "Quiz Fråga",
    "choiceElements" : "Choice Komponenter",
    "otherElements" : "Annan Komponenter",
    "listEditor" : {
      "prefillValueHeader" : "Värde för Fyll i på förhand",
      "labelPlaceholder" : "Etikett",
      "valuePlaceholder" : "Värde",
      "optionRequiredError" : "Alternativet Fält är Krävs"
    },
    "field" : "Fält",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Lägg till Fält",
      "fieldLabel" : "Fält",
      "numberLabel" : "siffra"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Fil",
      "all" : "varje",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "Ok",
    "select" : "Välj",
    "allowMultipleFiles" : "Aktivera Multiple Filer",
    "maxFileLimit" : "Max Fil",
    "privacyPolicy" : "Sekretesspolicy",
    "termsOfService" : "Villkor för tjänsten"
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Individuellt val",
      "multipleChoice" : "Flervalsalternativ",
      "yesNo" : "Ja / Nej",
      "shortAnswer" : "Kort Besvarad",
      "longAnswer" : "Långa Besvarad",
      "number" : "siffra",
      "singleDropdown" : "Individuell Rullgardinsmeny",
      "multiDropdown" : "Flera Rullgardinsmeny"
    },
    "personal" : {
      "fullName" : "Full Namn",
      "firstName" : "Förnamn",
      "lastName" : "senaste Namn",
      "dateOfBirth" : "Födelsedatum",
      "phone" : "Telefon",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Knapp"
    },
    "integration" : {
      "sellProducts" : "Sälj produkter",
      "collectPayment" : "Ta emot Utbetalning"
    },
    "address" : {
      "address" : "Adress",
      "streetAddress" : "Adress",
      "city" : "Stad",
      "state" : "Delstat",
      "country" : "Land",
      "postalCode" : "Postal Kod",
      "organization" : "Grupp",
      "website" : "Webbplats",
      "websitePlaceholder" : "URL går här"
    },
    "text" : {
      "singleLine" : "Enskild Linje",
      "multiLine" : "Flera Linje",
      "textBoxList" : "SMS:a Fyrkant Lista"
    },
    "choiceElements" : {
      "singleDropdown" : "Individuell Rullgardinsmeny",
      "multiDropdown" : "Flera Rullgardinsmeny",
      "checkbox" : "Kryssruta",
      "radio" : "Alternativknapp"
    },
    "customized" : {
      "text" : "SMS:a",
      "html" : "Html",
      "htmlPlaceholder" : "Den Anpassad HTML-koden finns här",
      "captcha" : "Captcha",
      "source" : "Källa",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Jag godkänner villkoren Utfärdade Via företaget. Via att uppge mitt telefonnummer godkänner jag Ärv SMS:a-meddelanden Från företaget.",
      "score" : "Poäng"
    },
    "other" : {
      "image" : "Bild",
      "fileUpload" : "Fil Ladda upp",
      "monetary" : "Monetärt",
      "number" : "siffra",
      "datePicker" : "Datum",
      "signature" : "Signatur"
    },
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble"
  },
  "survey" : {
    "typeOfBuilder" : "Undersökning",
    "survyeStyle" : "Undersökningsstil",
    "surveyName" : "Undersökningsnamn",
    "surveyElement" : "Undersökningselement",
    "addSurveyElement" : "Lägg till undersökningselement",
    "cloneSlide" : "Klona sida",
    "unsavedAlertMessage" : "Undersökningen har arbete som inte har sparats. Är du säker på att du vill lämna och kasta allt osparat arbete?",
    "thirdPartyScriptAlertMessage" : "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i undersökningen.",
    "integrateHeader" : "Integrera undersökning",
    "integrateSubHeader" : "Använd följande alternativ för att integrera din anpassade undersökning på en webbplats",
    "integrateCopyLinkMessage" : "Kopiera länken nedan och dela den enkelt var du vill.",
    "onSurveySubmission" : "Vid undersökningsinlämning",
    "surveySettings" : "Undersökningsinställningar",
    "oneQuestionAtTime" : "En fråga i taget",
    "backButton" : "Tillbaka-knapp",
    "backButtonTooltipMessage" : "Back button will help users to move to the previous slide",
    "disableAutoNavigation" : "Inaktivera automatisk navigering",
    "disableAutoNavigationTooltipMessage" : "Navigerar automatiskt till Nästa Skjut Efter a Användare svarar.",
    "autoNavigation" : "Auto navigering",
    "autoNavigationTooltipMessage" : "Navigerar automatiskt till Nästa Skjut Efter a Användare svarar.",
    "progressBar" : "Förloppsfält",
    "progressBarTooltipMessage" : "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation" : "Inaktivera animation",
    "disableAnimationTooltipMessage" : "Om du aktiverar det här inaktiveras animationen för bildövergångar",
    "scrollToTop" : "Skrolla till toppen",
    "scrollToTopTooltipMessage" : "Om det är aktiverat skrollas undersökningen till toppen på nästa bild",
    "footerHTML" : "HTML för sidfot",
    "footerHTMLMessage" : "Du kan skriva anpassad CSS (med hjälp av stiltaggar) och HTML i samma ruta",
    "editFooter" : "Redigera sidfot",
    "disqualifySettings" : "Disqualify Settings",
    "disqualifyImmediately" : "Diskvalificera omedelbart",
    "disqualifyAfterSubmit" : "Diskvalificera efter inlämning",
    "disqualifyImmediatelyLabel" : "Immediately",
    "disqualifyAfterSubmitLabel" : "After Submit",
    "slideConflictAlertMessage" : "Den här bilden innehåller flera frågor med inställd logik. Detta kan orsaka oavsiktligt beteende",
    "addSlide" : "Lägg till bild",
    "settings" : "Inställningar",
    "delete" : "Radera",
    "slideDeleteAlertMessage" : "Är du säker på att du vill ta bort den här bilden?",
    "slideDeleteBetweenAlertMessage" : "Detta kommer att omorganisera de andra bilderna. Är du säker på att du vill ta bort den här bilden?",
    "slideLabel" : "Slide {n}",
    "slideName" : "Bildens namn",
    "slidePosition" : "Bildens placering",
    "jumpTo" : "Hoppa till",
    "jumpToSubText" : "Jump to a specific slide",
    "enableTimezoneSurvey" : "Om du aktiverar det här alternativet registreras information om tidszon för den person som skickar in undersökningen",
    "footer" : {
      "footer" : "Sidfot",
      "enableNewFooter" : "Aktivera ny sidfot",
      "stickToSurvey" : " Fäst till undersökning",
      "backgroundFill" : "Bakgrundsfyllnad",
      "footerHeight" : "Sidfotshöjd",
      "enableProgressBar" : "Aktivera förloppsindikator",
      "buttons" : "Knappar",
      "button" : "Knapp",
      "buttonType" : "Knapptyp",
      "fillNext" : "Fyll (nästa)",
      "fillPrevious" : "Fyll (föregående)",
      "fillSubmit" : "Fyll i (skicka)",
      "textColor" : "Knapptext",
      "position" : "Position",
      "previousText" : "Föregående (text)",
      "nextText" : "Nästa (text)",
      "submitText" : "Skicka (text)",
      "fillComplete" : "Fyllning vid komplett",
      "fillInactive" : "Fyllning vid inaktiv",
      "footerType" : "Sidfotstyp",
      "stickToCard" : "Håll dig till kortet",
      "stickToPage" : "Håll dig till sidan",
      "stepTextColor" : "Steg Brödtext Färg",
      "progressBarFill" : "Förloppsfält Fyll",
      "progressBarInactive" : "Förloppsfält Inaktiv",
      "arrowFill" : "Fyll med Pil",
      "submitColorMobile" : "Skicka (Färg)",
      "arrowFillColor" : "Pil Fyll Färg"
    },
    "surveyNotfication" : "Undersökningsavisering",
    "style" : {
      "surveyPadding" : "Undersökningsutfyllnad"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Survey",
      "share" : {
        "openFormLink" : "Öppna Undersökning Länk"
      },
      "email" : {
        "emailSubheader" : "Skapa ett tomt E-inlägg och Inbäddad din Undersökning, Eller Välj a Mall och Inbäddad it Omedelbart."
      }
    },
    "autoResponderSubheader" : "Skicka ett automatiskt e-postmeddelande till personen som skickar in undersökningen (e-postmeddelandet innehåller en kopia av den information som de angav i undersökningen)",
    "switchToOneQuestionAtTimeOn" : "Om du aktiverar ”En fråga vid ett datum” störs din Nuvarande villkorliga Logik",
    "switchToOneQuestionAtTimeOff" : "Inaktivera ”En fråga vid ett datum” påverkar din villkorliga Logik Config",
    "switchToOneQuestionAtTimeOnWarning" : "Vissa villkor kommer inte längre att fungera som förväntat När-frågor är Deltog one at a Datum.",
    "switchToOneQuestionAtTimeOffWarning" : " Vissa villkor avsedda för individuell fråga Flöde slutar fungera som avsett.",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey."
  },
  "form" : {
    "typeOfBuilder" : "Formulär",
    "formStyle" : "Formulärstil",
    "formElement" : "Formulärelement",
    "addFormElement" : "Lägg till formulärelement",
    "addConditionalLogic" : "Lägg till villkorlig logik",
    "openConditionalLogic" : "Open Conditional Logic",
    "inlineForm" : "Infogat formulär",
    "formName" : "Formulärnamn",
    "fullScreenMode" : "Fullskärmsläge",
    "fullScreenModetooltip" : "Om du aktiverar det kommer formuläret att expanderas över hela behållarens bredd och sträcka sig till kanten av inbäddningsområdet samtidigt som det följer formulärets bredd.",
    "enableTimezoneForm" : "Om du aktiverar det här alternativet registreras information om tidszon för den person som skickar in formuläret",
    "formSettings" : "Formulärinställningar",
    "unsavedAlertMessage" : "Formuläret har arbete som inte har sparats. Är du säker på att du vill lämna och kasta allt osparat arbete?",
    "thirdPartyScriptAlertMessage" : "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i formuläret.",
    "onFormSubmission" : "Vid formulärinlämning",
    "integrateForm" : "Integrera formulär",
    "embedlayoutType" : "Inbäddad Layout Typ",
    "embedlayoutTypeSubMessage" : "Välj en layout för att bädda in i en tratt eller extern webbplats",
    "triggerType" : "Utlösartyp",
    "showOnScrolling" : "Visa vid skrollning",
    "showAfter" : "Visa efter",
    "seconds" : "sekunder",
    "alwaysShow" : "Visa alltid",
    "activationOptions" : "Aktiveringsalternativ",
    "activateOn" : "Aktivera vid",
    "visit" : "besök",
    "alwaysActivated" : "Alltid aktiverad",
    "deactivationOptions" : "Inaktiveringsalternativ",
    "deactivateAfterShowing" : "Inaktivera efter visning",
    "times" : "gånger",
    "deactiveOnceLeadCollected" : "Inaktivera när potentiell kund har registrerats",
    "neverDeactivate" : "Inaktivera aldrig",
    "copyEmbedCode" : "Kopiera inbäddningskod",
    "copyFormLink" : "Kopiera formulärlänk",
    "openFormLink" : "Öppna formulärlänk",
    "inline" : "Infogat",
    "inlineDescription" : "Ett infogat formulär visas tillsammans med innehållet på sidan som ett inbyggt element. Den ligger inte ovanpå sidan och kan inte stängas eller minimeras.",
    "inlineHoverDescription" : "Ett infogat formulär visas tillsammans med innehållet på sidan som ett inbyggt element. Den ligger inte ovanpå sidan och kan inte stängas eller minimeras.",
    "popup" : "Popup",
    "popupDescription" : "Ett popup-fönster visar formulär som ett överlägg inuti ett fönster. Det kan inte minimeras utan måste stängas.",
    "popupHoverDescription" : "Ett popup-fönster visar formulär som ett överlägg inuti ett fönster. Det kan inte minimeras utan måste stängas.",
    "politeSlideIn" : "Artigt insegel",
    "politeSlideInDescription" : "Ett artigt insegel visas längst ned på skärmen och försvinner när det stängs",
    "politeSlideInHoverDescription" : "Visas på skärmens undersida och försvinner när den stängs",
    "stickySidebar" : "Fäst sidofält",
    "stickySidebarDescription" : "Ett fäst sidofält visas på sidan av skärmen och kan minimeras till en flik som fästs vid sidan av fönstret",
    "stickySidebarHoverDescription" : "Visas på sidan av skärmen och kan minimeras till en flik som fästs vid sidan av fönstret",
    "allowMinimize" : "Tillåt minimering",
    "conditonalLogic" : {
      "conditions" : "Villkor",
      "noExistingCondition" : "Inga befintliga villkor än",
      "freeRoamMessage" : "Du kan ströva fritt utan reglerna – för tillfället i alla fall",
      "addNewCondition" : "Lägg till nytt villkor",
      "redirectToUrl" : "Omdirigera till URL",
      "displayCustomMessage" : "Visa anpassat meddelande",
      "disqualifyLead" : "Diskvalificera potentiell kund",
      "showHideFields" : "Visa/dölj fält",
      "jumpTo" : "Jump To",
      "redirectToUrlSubText" : "Omdirigera Användare efter inlämning",
      "displayCustomMessageSubText" : "Visa-meddelanden baserade På Användare-ingångar",
      "disqualifyLeadSubText" : "Filtrera bort poster under specifika förhållanden",
      "showHideFieldsSubText" : "Ändra Fält Synlighet dynamiskt",
      "openBelowUrl" : "Öppna nedanstående URL",
      "showCustomMessage" : "Visa anpassat meddelande",
      "alertConditionDelete" : "Är du säker på att du vill ta bort det här villkoret?",
      "deleteCondition" : "Ta bort villkor",
      "conditionExecutedMessage" : "Villkoren kommer att exekveras uppifrån och ned.",
      "allOperationOptions" : {
        "isEqualTo" : "Är lika med",
        "isNotEqualTo" : "Är inte lika med",
        "contains" : "Innehåller",
        "startsWith" : "Börjar med",
        "endsWith" : "Slutar med",
        "isEmpty" : "Är tom",
        "isFilled" : "Är fylld",
        "before" : "Före",
        "after" : "Efter",
        "greaterThan" : "Större än",
        "lessThan" : "Mindre än"
      },
      "logic" : {
        "if" : "Om",
        "then" : "Gör därefter",
        "and" : "Och",
        "or" : "Eller"
      },
      "phoneAlertMessage" : "För att söka efter telefonnummer med landskod måste du inkludera symbolen ”+” i din sökfråga.",
      "deleteAlertMessage" : "Är du säker på att du vill ta bort det här fältet? Villkoret för fältet kommer också att tas bort.",
      "deleteField" : "Ta bort fält",
      "jumpToDescription" : "Jump to a specific slide when conditions are met",
      "jumpToSlide" : "Jump To Slide",
      "selectSlideToJumpTo" : "Select slide to jump to",
      "selectedSlide" : "Selected slide"
    },
    "minimizedTitlePlaceholder" : "Minimerad titel",
    "dragYourElementFromLeft" : "Dra dina element hit från vänster",
    "formNotification" : "Formuläravisering",
    "style" : {
      "formPadding" : "Formutfyllnad"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Form",
      "share" : {
        "openFormLink" : "Öppna Formulär länk"
      },
      "email" : {
        "emailSubheader" : "Skapa ett tomt E-inlägg och Inbäddad din Formulär, Eller Välj a Mall och Inbäddad it Omedelbart."
      }
    },
    "choosePosition" : "Välj Status"
  },
  "quiz" : {
    "quizElement" : "Quizelement",
    "quizNotification" : "Quizavisering",
    "viewAndCustomise" : "Visa och anpassa",
    "categoryAndScore" : "Kategori och poäng",
    "provideFeedback" : "Ge feedback",
    "addQuizElement" : "Lägg till quizelement",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Lägg till frågor",
    "dragAndDropQuestion" : "Dra och släpp ett Fråga här.",
    "addNewPage" : "Lägg till Ny Sida",
    "editTemplate" : "Redigera Mall",
    "clonePage" : "Clone Page",
    "category" : {
      "category" : "Kategori",
      "watchVideo" : "Visa den här Video för att lära dig mer Om Hur Kategori påverkar resultaten Sida!",
      "useCategoryWhen" : "Använd Kategorier När",
      "manageCategories" : "Hantera Kategorier",
      "howItWorks" : "Hur fungerar det här 🤔",
      "howItWorks2" : "Hur fungerar det här",
      "addCategoryMessage" : "Lägg till en ny kategori",
      "assignCategoryMessage" : "Tilldela ett alternativ i Kategori till varje",
      "editResultsMessage" : "Visa Kategori-partitur in Resultat Sida",
      "addCategory" : "Lägg till Kategori",
      "deleteCategoryAlertMessage" : "Om du Raderar en Kategori resulterar du i vila av den Kategori in varje Alternativ",
      "editOrAddNewCategories" : "Du can Redigera Eller Inkludera Ny Kategorier",
      "toEvaluateTheResponder" : "Till Jämför baserade respondern På flera faktorer",
      "showMultipleCategoryScore" : "Visa multipla Kategori-partitur in Resultat Sida",
      "displayVaryingContent" : "Visning varierande Innehåll På resultaten Sida beroende På Poängnivån Kategori",
      "theOptionFieldIsRequired" : "The option field is required",
      "addManage" : "Lägg till / Hantera"
    },
    "quizSettings" : "Quizinställningar",
    "onQuizSubmission" : "Vid quizinlämning",
    "settings" : "Inställningar",
    "deletePage" : "Ta bort sida",
    "quizResult" : {
      "resultTemplate" : "Resultatmall",
      "quizResultAlertMessage" : "Vald resultatsida kommer att visas när quizet är klart"
    },
    "autoResponderSubheader" : "Skicka ett automatiskt e-postmeddelande till personen som skickar in quizet (e-postmeddelandet innehåller en kopia av den information som de angav i quizet)",
    "integrateHeader" : "Integrera quiz",
    "integrateSubHeader" : "Använd följande alternativ för att integrera ditt anpassade quiz på en webbplats",
    "integrateCopyLinkMessage" : "Kopiera länken nedan och dela den enkelt var du vill.",
    "pageLabel" : "Page {n}",
    "pageName" : "Sidnamn",
    "pagePosition" : "Sidposition",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Quiz",
      "share" : {
        "openFormLink" : "Öppna Quiz- Länk"
      },
      "email" : {
        "emailSubheader" : "Skapa ett tomt E-inlägg och Inbäddad ditt quiz, Eller Välj en Mall och Inbäddad it Omelbart."
      }
    }
  }
}
